import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
const chips = ['6 Volumes', '52 Weeks', '300 Pages', '30 · 45 · 55-min versions', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Print it or teach from your phone'];
export function Hero() {
  return <section className="w-full bg-plum-deep" data-id="element-111" data-mp="4njq6ckn7zc1">
      <div className="max-w-6xl mx-auto px-5 pt-8 pb-16 sm:pt-12 sm:pb-20" data-id="element-112" data-mp="12a0kra1zryu3">
        <div className="grid items-center gap-8 lg:grid-cols-[1.05fr_.95fr] lg:gap-12" data-id="element-113" data-mp="xae8b2tzmmmc">
          <div data-id="element-114" data-mp="x8jndoipuui9">
            <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-115" data-mp="sb1axo5hpx5i">
              The 52-Week Barre Map · for barre instructors
            </p>
            <h1 className="mt-4 font-display font-semibold text-white text-[40px] leading-[1.04] tracking-tight sm:text-6xl md:text-[68px]" data-id="element-116" data-mp="nbydopvr4v83">
              Your whole year of barre classes,{' '}
              <span className="italic text-gold" data-id="element-117" data-mp="3814cxsua24px">already mapped.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-white/75" data-id="element-118" data-mp="3j925rpk1dsw2">
              52 Weeks of Barre is six volumes with a ready-to-teach class for
              every week of the year — counted in 8s, cued, with an easy and a
              hard version and a BPM for every block. Open the week, pick your
              length, teach.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-119" data-mp="30hhq1o505f02">
              {chips.map(chip => <li key={chip} className="rounded-full border border-plum-line px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-white/70" data-id="element-120" data-mp="358hoixtrs54o">
                  {chip}
                </li>)}
            </ul>
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/u9MtsPdybe1RfxtW8Jdkk8/hf_20260924_190605_eab8ff2a-bff4-4d45-b097-442d2d9c2fc6.png" alt="The six spiral-bound volumes of 52 Weeks of Barre, from Foundations to Restore & Reset" width={1024} height={688} className="w-full h-auto rounded-2xl" data-id="element-121" data-mp="2hinawe1mmcjd" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-122" data-mp="ic891hh2wayw">
          <div className="w-full max-w-md" data-id="element-123" data-mp="icrs51igt5ei">
            <CtaButton data-id="element-124" data-mp="ddf4wfnolwbe">Get 52 Weeks of Barre</CtaButton>
          </div>
          <div className="mt-5" data-id="element-125" data-mp="db2erf7rsfn9">
            <RatingProof data-id="element-126" data-mp="1b1fgx72facwt" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-white/70" data-id="element-127" data-mp="1b0dt020b5vxo">
            Written for independent, gym, YMCA and small-studio instructors who
            build their own classes. No certification lock-in, no subscription.
          </p>

          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-128" data-mp="x1edpkyoqte6">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-129" data-mp="3ltqbtahzursg">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-130" data-mp="3hqu2kaecg816" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}